import { render } from "./LoginBasic.vue?vue&type=template&id=7cf915a8"
import script from "./LoginBasic.vue?vue&type=script&lang=js"
export * from "./LoginBasic.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__